import { lazy } from 'react';

import { createBrowserHistory, History } from 'history';

import RoutePaths from 'common/config/routes/route-paths';
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const CommonRoutes = [
  {
    path: RoutePaths.commonIdentityValidation,
    component: lazy(() => import('common/pages/identity-validation')),
  },
  {
    path: RoutePaths.commonProfile,
    component: lazy(() => import('common/pages/profile-page')),
  },
  {
    path: RoutePaths.commonAddCard,
    component: lazy(
      () => import('common/modules/payment-methods/@components/credit-card/@pages/credit-card-add'),
    ),
  },
  {
    path: RoutePaths.commonSelectCard,
    component: lazy(
      () =>
        import('common/modules/payment-methods/@components/credit-card/@pages/credit-card-list'),
    ),
  },
  {
    path: RoutePaths.commonNotFoundPage,
    component: lazy(() => import('common/pages/error/not-found')),
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const history: History<any> = createBrowserHistory();
